import ViewClaim from 'components/ViewClaims/ViewClaims.component';

const ClaimsNotificationsPage = () => {
	return <ViewClaim isNotifications />;
};

export default ClaimsNotificationsPage;
